export default __webpack_public_path__ + "static/media/navbar-icon-users-menu.bb0ec878.svg";